import { CLIENT_BRANCH_API } from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { BranchPromotionSlideModel, IBranchModel } from "./branch.models";

export const getBranchesAPI = async () => {
  return await apiClient.getHttp<IBranchModel[]>(
    `${CLIENT_BRANCH_API}`,
    undefined,
    false
  );
};

export const getBranchPromotionSlideAPI = async (branchId: number) => {
  return await apiClient.getHttp<BranchPromotionSlideModel[]>(
    `${CLIENT_BRANCH_API}/${branchId}/promotion_slide`,
    undefined,
    false
  );
};
